const ROUTE_CONTENT_READY_EVENT = 'jss:route-content-ready';

const nextFrame = () =>
  new Promise((resolve) => {
    window.requestAnimationFrame(resolve);
  });

const waitForScrollableHeight = (targetTop, timeout = 2500) =>
  new Promise((resolve) => {
    const startedAt = Date.now();

    const checkHeight = () => {
      const documentHeight = Math.max(
        document.documentElement.scrollHeight,
        document.body.scrollHeight
      );
      const maxScrollTop = Math.max(documentHeight - window.innerHeight, 0);

      if (maxScrollTop >= targetTop || Date.now() - startedAt >= timeout) {
        resolve();
        return;
      }

      window.requestAnimationFrame(checkHeight);
    };

    checkHeight();
  });

export const notifyRouteContentReady = (fullPath) => {
  if (typeof window === 'undefined') return;

  window.dispatchEvent(
    new CustomEvent(ROUTE_CONTENT_READY_EVENT, {
      detail: { fullPath },
    })
  );
};

export const waitForRouteScrollReady = (fullPath, targetTop = 0, timeout = 10000) => {
  if (typeof window === 'undefined') return Promise.resolve();

  return new Promise((resolve) => {
    let timer;

    const cleanup = () => {
      window.removeEventListener(ROUTE_CONTENT_READY_EVENT, onContentReady);
      window.clearTimeout(timer);
    };

    const finish = async () => {
      cleanup();
      await nextFrame();
      await nextFrame();
      await waitForScrollableHeight(Number(targetTop) || 0);
      resolve();
    };

    const onContentReady = (event) => {
      if (event.detail?.fullPath !== fullPath) return;
      finish();
    };

    window.addEventListener(ROUTE_CONTENT_READY_EVENT, onContentReady);
    timer = window.setTimeout(finish, timeout);
  });
};
